import { Scene } from 'phaser'
import startImage from '@/game/jump/assets/images/start.png'
import padImage_1 from '@/game/jump/assets/images/pad_1.png'
import padImage_2 from '@/game/jump/assets/images/pad_2.png'
import padImage_3 from '@/game/jump/assets/images/pad_3.png'
import PlayerImage from '@/game/jump/assets/images/playerSprite2.png'

export default class BootScene extends Scene {
  constructor () {
    super({ key: 'BootScene' })
  }

  preload () {
    this.load.image('start', startImage)
    this.load.image('pad_1', padImage_1)
    this.load.image('pad_2', padImage_2)
    this.load.image('pad_3', padImage_3)

    this.load.spritesheet('player', PlayerImage, {
      frameWidth: 200,
      frameHeight: 200,
      margin: 0,
      spacing: 0
    })
  }

  create () {
    this.scene.start('PlayScene')
  }
}
